import React, { useMemo } from "react";

const BranchBenchmarkTable = ({ branches }) => {

  const sortedBranches = useMemo(() => {
    if (!branches) return [];
    return [...branches].sort(
      (a, b) => b.totals.kWh_equiv - a.totals.kWh_equiv
    );
  }, [branches]);

  const totalEnergy = useMemo(() => {
    return sortedBranches.reduce(
      (sum, b) => sum + (b.totals?.kWh_equiv || 0),
      0
    );
  }, [sortedBranches]);

  const topBranchId = sortedBranches?.[0]?.branchId;

  const getCarrierValue = (branch, carrierId) => {
    const carrier = branch.carriers?.find((c) => c.id === carrierId);
    if (!carrier) return 0;
    return carrier.energy_kWh_equiv ?? carrier.kWh_equiv ?? 0;
  };

  const getSourceLabel = (branch) => {
    if (!branch.totals?.kWh_equiv) return "—";

    const source = branch.sourceInfo?.energy_source;

    if (source === "invoice") return "Factura";
    if (source === "meter") return "Medidor";
    if (source === "mixed") return "Mixto";

    return "—";
  };

  return (
    <div className="em-table-section em-benchmark-card">
      <div>
        <h3>Consumo energético por sucursal</h3>
      </div>

      <div className="em-table-wrapper">
        <table className="em-table">
          <thead>
            <tr>
              <th>Sucursal</th>
              <th>Fuente</th>
              <th>Electricidad (kWh)</th>
              <th>Gas (kWh eq)</th>
              <th>Total (kWh eq)</th>
              <th>Distribución</th>
            </tr>
          </thead>

          <tbody>
            {sortedBranches.map((b) => {

              const electricity = getCarrierValue(b, "electricity");
              const gas = getCarrierValue(b, "gas");

              const total = b.totals?.kWh_equiv || 0;

              const percent =
                totalEnergy > 0 ? (total / totalEnergy) * 100 : 0;

              const isTop = b.branchId === topBranchId;

              return (
                <tr key={b.branchId} className={isTop ? "em-top-branch" : ""}>
                  <td>{b.branchName}</td>

                  <td>{getSourceLabel(b)}</td>

                  <td>{electricity.toFixed(2)}</td>

                  <td>{gas.toFixed(2)}</td>

                  <td>{total.toFixed(2)}</td>

                  <td style={{ minWidth: "180px" }}>
                    <div
                      style={{
                        background: "#eee",
                        borderRadius: "6px",
                        height: "10px",
                        position: "relative",
                        overflow: "hidden"
                      }}
                    >
                      <div
                        style={{
                          width: `${percent}%`,
                          background: "#2f80ed",
                          height: "100%",
                          transition: "width 0.3s ease"
                        }}
                      />
                    </div>

                    <div style={{ fontSize: "12px", marginTop: "4px" }}>
                      {percent.toFixed(1)}%
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BranchBenchmarkTable;